import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IssueRaisingEventsService {
  readonly objectiveAdded$ = new Subject<number>();
}
